import { DataFactory } from "n3";
export var RdfTermType;
(function (RdfTermType) {
    RdfTermType["BlankNode"] = "BlankNode";
    RdfTermType["NamedNode"] = "NamedNode";
    RdfTermType["Literal"] = "Literal";
    RdfTermType["DefaultGraph"] = "DefaultGraph";
    RdfTermType["Variable"] = "Variable";
    RdfTermType["Quad"] = "Quad";
})(RdfTermType || (RdfTermType = {}));
export const RdfNode = {
    DEFAULT_GRAPH: "",
    namedNode: DataFactory.namedNode,
    defaultGraph: DataFactory.defaultGraph,
};
export const RdfObject = {
    isNotNode(object) {
        return !RdfObject.isNode(object);
    },
    isNode(object) {
        return (object.termType === RdfTermType.NamedNode ||
            object.termType === RdfTermType.BlankNode);
    },
    isLiteral(object) {
        return object.termType === RdfTermType.Literal;
    },
};
//# sourceMappingURL=rdf-api.js.map